"use client";

import { useGeo } from "@/i18n/routing";
import type { GeoLocale } from "@frend-digital/next/i18n";
import { clsx } from "@frend-digital/ui";
import Image from "next/image";
import { startTransition } from "react";
import { Button } from "../button";
import styles from "./index.module.css";

type FlagButtonProps = {
	className?: string;
	text?: string;
	countryCode?: string;
	selected?: boolean;
};

export const FlagButton = ({
	text,
	countryCode,
	selected,
	className,
}: FlagButtonProps) => {
	const { action, pending: _, language, country: currentCountry } = useGeo();

	const handleCountryChange = () => {
		startTransition(() => {
			action(`${language}-${countryCode}` as GeoLocale);
		});
	};

	return (
		<Button
			className={clsx(styles.root, selected && styles.selected, className)}
			onClick={(e) => {
				e.preventDefault();
				handleCountryChange();
			}}>
			<div className={styles.main}>
				{countryCode && (
					<div className={styles.flagImage}>
						<Image
							src={`https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`}
							alt=""
							width={64}
							height={64}
						/>
					</div>
				)}
				<span className={clsx(styles.text)}>{text}</span>
			</div>
		</Button>
	);
};
